import api from "api/api";
import { CORRESPONDENCE_TABLE_CSLT_STR_FILTER_OPTIONS } from "constants/constants";

export const getTimelineQuery = ({
  type,
  id,
  isToolsManager,
  orderBy,
  userScope,
  missionsOnly,
}) => {
  const typeSettings = {
    staff: "manager-id",
    cslt_str: "worker-id",
    client: "client-id",
  };
  const params = new URLSearchParams({
    [typeSettings[type]]: id,
  });
  !isToolsManager && userScope && params.set("scope", userScope);
  orderBy && params.set("order-by", orderBy);
  missionsOnly && params.set("only-missions", "true");
  return api.get(`/timeline?${params.toString()}`);
};

export const getMissionsByStaffIdQuery = async ({ id, userScope }) =>
  await api.get(`/missions/staff/${id}?scope=${userScope}`);

export const getMissionsByWorkerIdQuery = async ({ id, userScope }) =>
  await api.get(`/missions/worker/${id}?scope=${userScope}`);

export const getCorrespondanceTimelineQuery = async ({
  worker_type,
  start_date,
  end_date,
  page,
}) => {
  const workerTypeParam =
    worker_type &&
    worker_type !== CORRESPONDENCE_TABLE_CSLT_STR_FILTER_OPTIONS[2].value
      ? `worker_type=${worker_type}&`
      : "";
  return await api.get(
    `/timeline/correspondances?${workerTypeParam}start_date=${start_date}&end_date=${end_date}&page=${page}`
  );
};

export const getLateCloseMissionByStaffIdQuery = async ({ id, userScope }) =>
  await api.get(`missions/staff/${id}/late/close?scope=${userScope}`);

export const getMissionClosedLessFifteenDaysBeforeEndsQuery = async ({
  id,
  userScope,
}) => await api.get(`missions/staff/${id}/late/before?scope=${userScope}`);

export const getLateCreatedMissionsByStaffIdQuery = async ({ id, userScope }) =>
  await api.get(`missions/staff/${id}/late/create?scope=${userScope}`);

export const createMissionQuery = async ({ data, userScope }) =>
  await api.post(`/mission?scope=${userScope}`, data);

export const getMissionsByFiltersQuery = async ({
  page,
  filters,
  userScope,
}) => {
  const queryParams = `/missions/search?page=${page}&per_page=${30}`;
  const filtersParam = filters ? `${filters}` : "";
  const userScopeParam = userScope ? `&scope=${userScope}` : "";
  const url = queryParams + filtersParam + userScopeParam;
  return await api.get(url);
};

export const getMissionByIdQuery = async ({ id, userScope }) =>
  await api.get(`/mission/${id}?scope=${userScope}`);

export const editMissionQuery = async ({ id, data, userScope }) =>
  await api.put(`/mission/id/${id}?scope=${userScope}`, data);

export const editMissionsPartialWithBillsQuery = async ({ data, userScope }) =>
  await api.put(`/missions/partial/with-bill?scope=${userScope}`, data);

export const getMissionBySlugQuery = async ({ slug, userScope }) =>
  await api.get(`/mission/slug/${slug}?scope=${userScope}`);

export const deleteMissionByIdQuery = async ({ id, userScope }) =>
  await api.delete(`/mission/${id}?scope=${userScope}`);

export const generateMissionPPTQuery = async ({ id, userScope }) =>
  await api.post(`/mission-export/slideshow/${id}?scope=${userScope}`);

export const generateAllMissionsPPTQuery = async ({ userScope, filters }) =>
  await api.post(
    `/mission-export/slideshow?scope=${userScope}&filter=${filters}`
  );

export const getMissionsExcelFileQuery = async ({ filters }) =>
  await api.post(`/mission-export/csv?filter=${filters}`);

export const missionQuoteQuery = async ({ missionId, userScope }) =>
  await api.post(`/mission-export/quote/${missionId}?scope=${userScope}`);

export const getMissionCSVQuery = async ({ filters, lang, userScope }) => {
  return api.getBlob(
    `/directory/search/missions-client/export?scope=${userScope}&search=${filters}&order=mission&lang=${lang}`
  );
};

export const getModalAccessForMissionsQuery = async ({
  missionId,
  userScope,
}) => await api.get(`/mission/access/${missionId}?scope=${userScope}`);
